import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精选内容 · 深度阅读
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            最热门的影视资讯、深度影评和追剧攻略，一站式了解最新电影在线看动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="aspect-[3/2] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {item.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.author}</span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}